import React, { Component, Fragment } from 'react';
import { Container, Grid, Typography } from '@material-ui/core';
import SpinnerComponent from '../../../components/SpinnerComponent';
import CustomSnackbar from '../../../components/CustomSnackbar';
import FormModificaGruppo from './FormModificaGruppo';
import TabellaConsulentiGruppo from './TabellaConsulentiGruppo';
import TabellaModelliPiattaforma from './TabellaModelliPiattaforma';
import TabellaModelliGruppo from './TabellaModelliGruppo';
import DialogConfirmOperation from '../components/DialogConfirmOperation';
import GoToButton from '../components/GoToButton';
import {
  getGruppo,
  getGruppi,
  updateGruppo,
} from '../../../utils/api/gruppi_api';
import {
  getConsulenti,
  updateConsulente,
} from '../../../utils/api/consulenti_api';
import {
  getModelli,
  clonaModelliPersonalizzati,
  cancellaModello,
  updateModello,
} from '../../../utils/api/modelli_and_manuali_api';
import PropTypes from 'prop-types';
import { reportApiError, reportError } from '../../../utils/reportApiError';

// The step named in the error dialog when one of the screen's reads fails.
const TITOLI_LETTURA = {
  gruppo: 'Caricamento del gruppo non riuscito',
  gruppi: 'Caricamento dei gruppi non riuscito',
  consulenti: 'Caricamento dei consulenti non riuscito',
  modelliPiattaforma: 'Caricamento dei modelli della piattaforma non riuscito',
  modelliGruppo: 'Caricamento dei modelli del gruppo non riuscito',
};

const styles = {
  root: {
    textAlign: 'center',
    color: 'black',
    paddingTop: '26px',
    paddingLeft: '4px',
    paddingRight: '4px',
    minHeight: '86vh',
  },
  texts: {
    marginBottom: '20px',
  },
};

export default class ModificaGruppoPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      originalNome: '',
      originalCostoUnitario: '',
      originalTipologiaPagamento: '',
      gruppo: {
        id: null,
        nome: '',
        brand: {
          id: null,
          nome: '',
        },
      },
      gruppi: [],
      consulenti: [],
      modelliPiattaforma: [],
      modelliGruppo: [],
      selectedModelli: [],
      isModalOpen: false,
      roleSuperconsulente: false,
      selectedConsulente: null,
      modalDescription: '',
      modalTitle: '',
      letturaGruppoFallita: false,
      changesNotSaved: false,
      editTable: false,
      selectedModelloId: null,
      snackbar: {
        open: false,
        message: '',
        severity: 'success',
      },
    };
  }

  componentDidMount() {
    this.bootstrap();
  }

  handleOpenSnackbar = (message, severity = 'success') => {
    this.setState({
      snackbar: {
        open: true,
        message,
        severity,
      },
    });
  };

  handleCloseSnackbar = () => {
    this.setState({
      snackbar: {
        open: false,
        message: '',
        severity: 'success',
      },
    });
  };

  // None of the five reads feeds another - the three that look up the group's
  // rows take the id from props, not from the group just read - so they run
  // together and the screen waits for one round trip instead of five. They can
  // now fail together too, and one dialog shows one message: the first failure
  // is reported and the rest are left to the empty tables they produce.
  bootstrap = () => {
    this.setState({ loading: true });
    const letture = [
      [this.fetchGruppo(), TITOLI_LETTURA.gruppo],
      [this.fetchGruppi(), TITOLI_LETTURA.gruppi],
      [this.fetchConsulenti(), TITOLI_LETTURA.consulenti],
      [this.fetchModelliPiattaforma(), TITOLI_LETTURA.modelliPiattaforma],
      [this.fetchModelliGruppo(), TITOLI_LETTURA.modelliGruppo],
    ];
    return Promise.all(
      letture.map(([lettura, titolo]) =>
        lettura.then(
          () => null,
          (error) => ({ error, titolo }),
        ),
      ),
    ).then((esiti) => {
      const fallita = esiti.find(Boolean);
      if (fallita) {
        reportApiError(fallita.error, fallita.titolo);
      }
      this.setState({ loading: false });
    });
  };

  /** One reload after a write: report what failed, and stop the spinner. */
  reload = (lettura, titolo) =>
    lettura
      .catch((error) => reportApiError(error, titolo))
      .then(() => this.setState({ loading: false }));

  fetchGruppo = () => {
    let gruppoId = this.props.gruppoId;
    return getGruppo(gruppoId)
      .then((result) => {
        this.setState({
          letturaGruppoFallita: false,
          gruppo: result,
          originalNome: result.nome,
          originalCostoUnitario: result.costoUnitario,
          originalTipologiaPagamento: result.tipologiaPagamento,
        });
      })
      .catch((error) => {
        // A group that could not be read is not a group that does not exist:
        // the render below tells the two apart on this flag.
        this.setState({
          letturaGruppoFallita: error.status !== 404,
        });
        throw error;
      });
  };

  fetchGruppi = () =>
    getGruppi(null, null, 0, 1000, 'id').then((result) => {
      this.setState({
        gruppi: result,
      });
    });

  fetchConsulenti = () =>
    getConsulenti(
      null,
      Number.parseInt(this.props.gruppoId),
      0,
      2000,
      'id',
    ).then((result) => {
      this.setState({
        consulenti: result,
      });
    });

  fetchModelliPiattaforma = () =>
    getModelli(false, null, false, 'PUBBLICATO', 0, 2000, 'id').then(
      (result) => {
        this.setState({
          modelliPiattaforma: result,
        });
      },
    );

  fetchModelliGruppo = () =>
    getModelli(
      false,
      Number.parseInt(this.props.gruppoId),
      false,
      null,
      0,
      3000,
      'id',
    ).then((result) => {
      this.setState({
        modelliGruppo: result,
      });
    });

  onDatiGruppoChanged = (event) => {
    const { name, value } = event.target;

    this.setState((prevState) => ({
      gruppo: {
        ...prevState.gruppo,
        [name]: value,
      },
    }));
  };

  onCostoUnitarioChanged = (event) => {
    const value = event.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      this.setState((prevState) => ({
        gruppo: {
          ...prevState.gruppo,
          costoUnitario: value,
        },
      }));
    }
  };

  saveChangesToGruppo = () => {
    this.setState({
      loading: true,
    });
    updateGruppo(this.state.gruppo)
      .then((result) => {
        let gruppo = result;
        this.setState({
          gruppo,
          changesNotSaved: false,
          originalNome: result.nome,
          originalCostoUnitario: result.costoUnitario,
          originalTipologiaPagamento: result.tipologiaPagamento,
        });
        // updateGruppo answers with the saved group, written into state just
        // above: re-reading it - and with it the consultants and models the
        // save never touched - would cost five more requests for nothing.
        this.setState({ loading: false });
        this.handleOpenSnackbar('Dati gruppo modificati con successo.');
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  openModalSuperconsulente = (consulente, event) => {
    const roleSuperconsulente = event.target.value;
    let modalTitle = 'Assegnamento del ruolo di superconsulente';
    let modalDescription =
      'Impostare il consulente ' +
      consulente.email +
      ' come superconsulente del gruppo ' +
      this.state.gruppo.nome +
      '?';
    if (!roleSuperconsulente) {
      modalTitle = 'Rimozione del ruolo di superconsulente';
      modalDescription =
        "Attenzione: se l'operazione verrà confermata, il consulente " +
        consulente.email +
        ' perderà i privilegi di superconsulente e non potrà più accedere ai contenuti del gruppo,' +
        ' ma solo a quelli direttamente associati al consulente.';
    }
    // The role the dialog is asking about is held on its own: the row keeps
    // showing what the backend holds until the change is confirmed and saved.
    this.setState({
      roleSuperconsulente,
      selectedConsulente: consulente,
      modalDescription,
      modalTitle,
      isModalOpen: true,
    });
  };

  closeModalWithoutChanges = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  changeRoleToConsulente = () => {
    this.setState({
      isModalOpen: false,
      loading: true,
    });
    const record = {
      ...this.state.selectedConsulente,
      superconsulente: this.state.roleSuperconsulente,
    };
    updateConsulente(true, record)
      .then((result) => {
        reportError(
          this.state.roleSuperconsulente
            ? "Il ruolo di superconsulente è stato assegnato all'utente selezionato."
            : "Il ruolo di superconsulente è stato tolto all'utente selezionato.",
          'Operazione effettuata',
        );
        this.reload(this.fetchConsulenti(), TITOLI_LETTURA.consulenti);
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        this.closeModalWithoutChanges();
        reportApiError(error);
      });
  };

  handleChangedSelection = (selectedRecord, event) => {
    // Read before the updater runs: React pools synthetic events, so
    // event.target is already null by the time setState calls back.
    const selezionato = event.target.checked;
    // Both branches build a new array: pushing into the one held in state and
    // handing it back to setState leaves the reference unchanged, and the
    // tables would then redraw only because something else changed with it.
    this.setState((prevState) => ({
      selectedModelli: selezionato
        ? [...prevState.selectedModelli, selectedRecord]
        : prevState.selectedModelli.filter(
            (modello) => modello.id !== selectedRecord.id,
          ),
    }));
  };

  cloneModelli = () => {
    // The clone endpoint requires a brandId, so a group without a brand has
    // nothing to clone into: say so rather than send a request that is refused.
    if (!this.state.gruppo.brand) {
      reportError(
        'Il gruppo non ha un brand associato: i modelli non possono essere clonati.',
        'Operazione non disponibile',
      );
      return;
    }
    this.setState({
      loading: true,
    });
    const selModelli = this.state.selectedModelli;
    let ids = [];
    for (let i = 0; i < selModelli.length; i++) {
      ids.push(selModelli[i].id);
    }
    clonaModelliPersonalizzati(
      this.state.gruppo.id,
      this.state.gruppo.brand.id,
      ids,
    )
      .then((result) => {
        // The models are in the group now: leaving them ticked would let a
        // second click clone the same ones again.
        this.setState({
          selectedModelli: [],
        });
        this.reload(this.fetchModelliGruppo(), TITOLI_LETTURA.modelliGruppo);
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  updateStatusModello = (modello, event) => {
    this.setState({
      loading: true,
    });
    // A copy, so a refused request leaves the row reading the state the
    // backend still holds. The reload below brings the new one back.
    updateModello({ ...modello, stato: 'PUBBLICATO' })
      .then((result) => {
        reportError('Il modello è stato pubblicato.', 'Operazione effettuata');
        this.reload(this.fetchModelliGruppo(), TITOLI_LETTURA.modelliGruppo);
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  removeModello = (modello, clickEvent) => {
    this.setState({
      loading: true,
    });
    cancellaModello(modello.id, true)
      .then((result) => {
        reportError('Il modello è stato cancellato.', 'Operazione effettuata');
        this.reload(this.fetchModelliGruppo(), TITOLI_LETTURA.modelliGruppo);
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  // The gear of the row being edited closes the editor; the gear of any other
  // row moves it there, rather than closing the one that is open.
  changeEditFlag = (selectedRecord, event) => {
    const isOpenOnThisRow =
      this.state.editTable &&
      this.state.selectedModelloId === selectedRecord.id;
    this.setState({
      selectedModelloId: isOpenOnThisRow ? null : selectedRecord.id,
      editTable: !isOpenOnThisRow,
    });
  };

  handleEditedModello = (modello, fieldName, value) => {
    let modelliGruppo = this.state.modelliGruppo;
    for (let i = 0; i < modelliGruppo.length; i++) {
      if (modelliGruppo[i].id === modello.id) {
        modelliGruppo[i][fieldName] = value;
        break;
      }
    }
    this.setState({
      modelliGruppo,
      changesNotSaved: true,
    });
  };

  saveUpdatesToModello = (modello, event) => {
    this.changeEditFlag(modello, null);
    this.setState({
      loading: true,
    });
    updateModello(modello)
      .then((result) => {
        this.setState({
          changesNotSaved: false,
        });
        this.reload(this.fetchModelliGruppo(), TITOLI_LETTURA.modelliGruppo);
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  render() {
    const isGroupFormDirty =
      this.state.gruppo.nome.trim() !== this.state.originalNome.trim() ||
      (this.state.gruppo.costoUnitario || '') !==
        (this.state.originalCostoUnitario || '') ||
      (this.state.gruppo.tipologiaPagamento || '') !==
        (this.state.originalTipologiaPagamento || '');
    const costoUnitarioError =
      String(this.state.gruppo.costoUnitario ?? '').length === 0
        ? 'Inserisci il costo per utenza'
        : '';
    return (
      <Container maxWidth={false} style={styles.root}>
        <Typography variant="h4" style={styles.texts}>
          Modifica i dati del gruppo
        </Typography>
        {this.state.loading ? (
          <SpinnerComponent size={24} />
        ) : this.state.letturaGruppoFallita ? (
          <Typography
            variant="h6"
            style={{ paddingTop: '6px', paddingBottom: '6px' }}
          >
            Caricamento del gruppo non riuscito. Ricaricare la pagina.
          </Typography>
        ) : this.state.gruppo.id === null ? (
          <Typography
            variant="h6"
            style={{ paddingTop: '6px', paddingBottom: '6px' }}
          >
            Record non trovato
          </Typography>
        ) : (
          <Fragment>
            <FormModificaGruppo
              gruppo={this.state.gruppo}
              onChange={this.onDatiGruppoChanged}
              onCostoUnitarioChange={this.onCostoUnitarioChanged}
              costoUnitarioError={costoUnitarioError}
              onSubmit={this.saveChangesToGruppo}
              isDirty={isGroupFormDirty}
            />
            <TabellaConsulentiGruppo
              gruppoId={this.state.gruppo.id}
              consulenti={this.state.consulenti}
              pendingConsulenteId={
                this.state.isModalOpen && this.state.selectedConsulente
                  ? this.state.selectedConsulente.id
                  : null
              }
              pendingSuperconsulente={this.state.roleSuperconsulente}
              onSelect={this.openModalSuperconsulente}
              disabled={false}
              changesNotSaved={this.state.changesNotSaved}
            />
            <Typography variant="h5" style={styles.texts}>
              Modelli base del gruppo
            </Typography>
            <TabellaModelliPiattaforma
              theme={this.props.theme}
              modelli={this.state.modelliPiattaforma}
              gruppi={this.state.gruppi}
              selectedModelli={this.state.selectedModelli}
              onSelectionChanged={this.handleChangedSelection}
              onSubmit={this.cloneModelli}
            />
            <Typography variant="h5" style={styles.texts}>
              Elenco dei modelli base del gruppo
            </Typography>
            <TabellaModelliGruppo
              theme={this.props.theme}
              modelli={this.state.modelliGruppo}
              selectedRecordId={this.state.selectedModelloId}
              edit={this.state.editTable}
              onStatoChanged={this.updateStatusModello}
              onEdit={this.changeEditFlag}
              onEditedCell={this.handleEditedModello}
              onSave={this.saveUpdatesToModello}
              onElimina={this.removeModello}
            />
            <Grid container justify="center">
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                style={{ marginBottom: '10px' }}
              >
                <GoToButton
                  showAlert={this.state.changesNotSaved || isGroupFormDirty}
                  path={'/amministrazione/gruppi'}
                  label="Torna alla tabella dei gruppi"
                  disabled={false}
                  grayVersion={false}
                />
              </Grid>
            </Grid>
          </Fragment>
        )}
        <DialogConfirmOperation
          open={this.state.isModalOpen}
          title={this.state.modalTitle}
          description={this.state.modalDescription}
          cancelButtonLabel="Annulla"
          confirmButtonLabel="Conferma"
          onCancel={this.closeModalWithoutChanges}
          onConfirm={this.changeRoleToConsulente}
        />
        <CustomSnackbar
          open={this.state.snackbar.open}
          message={this.state.snackbar.message}
          severity={this.state.snackbar.severity}
          onClose={this.handleCloseSnackbar}
        />
      </Container>
    );
  }
}

ModificaGruppoPage.propTypes = {
  gruppoId: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
};
